var map = {
	"./Settings_act.png": "fe6c",
	"./customer_act.png": "9c16",
	"./facebook_api_act.png": "e61d",
	"./instagram_act.png": "3985",
	"./language_act.png": "2de7",
	"./logout_act.png": "7a35",
	"./mine_act.png": "da63",
	"./telegram_act.png": "fa69",
	"./twitter_act.png": "22f5",
	"./wechat_act.png": "1de5",
	"./whatsapp_act.png": "d2fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9041";